<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App", 
};
</script>

  <style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000;
  margin-top: 60px;
  margin: 0;
  padding: 0;
  height: 100%;
}
/* 在 global.css 或者 main.css 中 */
body {
  background-color: #edf3fc; /* 设置你喜欢的背景颜色 */
}
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: #edf3fc;
  margin: 2px;
}

::-webkit-scrollbar {
  width: 11px;
  height: 11px;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color: #edf3fc;
  border: 2px solid transparent;
  background-clip: padding-box;
}
</style>
